import HeadBlock from "../components/HeadBlock";
import Header from "../components/Header";
import Nav from "../components/Nav";
import styles from "../assets/styles/aboutPlans.module.scss";
import iconStyles from "../assets/styles/icon.module.scss";
import ColoredSubscriptionDescription from "../assets/images/colored_subscription_description.png";
import { useNavigate } from "react-router-dom";

export const AboutPlans = () => {
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    navigate("/subscription");
  };

  return (
    <>
      <HeadBlock title="作品の購入・聴き放題プランについて" />
      <Header />
      <div className={styles.container}>
        <div className={styles.inner}>
          <h1 className={styles.coloerd_heading}>
            作品の購入・
            <br />
            聴き放題プランについて
          </h1>

          <section>
            <h2 className={styles.color_icon_heading}>
              <i className={iconStyles.icon_subscription}></i>
              聴き放題プラン
              <span>(月額¥500)</span>
            </h2>
            <img
              className={styles.colored_subscription_description}
              src={ColoredSubscriptionDescription}
              alt="colored_subscription_description"
            />

            <button
              className={styles.link_button}
              type="button"
              onClick={handleClick}
            >
              <i className={iconStyles.icon_subscription}></i>
              聴き放題で楽しむ（月額¥500）
            </button>
          </section>

          <section>
            <h2 className={styles.normal_icon_heading}>
              <i className={iconStyles.icon_check}></i>
              作品の購入
            </h2>
            <div className={styles.description_list_container}>
              <ul className={styles.description_list}>
                <li>作品を購入すると、全チャプターの視聴が可能です</li>
                <li>
                  購入した作品はサブスクへの登録・解約に関わらず、アカウント情報に紐づいて保存されます
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
      <Nav />
    </>
  );
};
